import {List, ListItemText} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import SteddiContainer from "../../General/SteddiContainer";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import {Calculator, CalendarDays, Coins, Gauge, Zap} from "lucide-react";
import useOrderState from "../../../stores/orderStore";
import DateHelpers from "../../../helpers/DateHelpers";
import Manedsbelop from "../InfoItems/Månedsbeløp";
import SectionHeader from "../../General/SectionHeader";
import DynamicListItem from "../../General/DynamicListItem";
import React from "react";
import {TopAlignedListItemAvatar} from "../../General/TopAlignedListItemAvatar";

export default function PriceInfoPage() {
  const state = useOrderState((state) => state)

  function getAnnualEstimate() {
    if (state.priceEstimate) {
      const amountOfMonths = 12 - state.paymentFreeMonths.length
      return Math.trunc(state.priceEstimate * amountOfMonths).toLocaleString()
    }
    return "---"
  }

  return (
    <Grid2 container spacing={2}>

      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding="sm" background={"tertiary"}>
          <SteddiInfoItem title={"Estimert årlig strømforbruk"} subtitle={state.totalEstimatedConsumption + " kWh"} icon={<Zap/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding="sm" background={"tertiary"}>
          <SteddiInfoItem title={"Estimert årlige kostnader"} subtitle={getAnnualEstimate() + " kroner"} icon={<Coins/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>

      <Grid2 xs={12}>
        <SteddiContainer>
          <SectionHeader>Ditt månedsbeløp</SectionHeader>
          <List sx={{pb: 0}} className="no-left-pad-list">
            <DynamicListItem>
              <TopAlignedListItemAvatar>
                <Calculator/>
              </TopAlignedListItemAvatar>
              <ListItemText>
                Månedsbeløpet ditt er basert på historikk om forbruket fra strømmåleren din – og beregninger av strømregningene dine de neste 12 månedene.
              </ListItemText>
            </DynamicListItem>
          </List>


          <Grid2 container spacing={2}>
            <Grid2 xs={12} sm={6}>
              <SteddiContainer padding="sm" background={"secondary"}>
                <Manedsbelop color="#DFFFF9"/>
              </SteddiContainer>
            </Grid2>
            <Grid2 xs={12} sm={6}>
              <SteddiContainer padding="sm" background={"secondary"}>
                <SteddiInfoItem title={"Din første forfallsdato"} subtitle={DateHelpers.toDateString(state.firstPaymentDue)} icon={<CalendarDays/>} bgColor={"#DFFFF9"}/>
              </SteddiContainer>
            </Grid2>
          </Grid2>

          <List sx={{pb: 0}} className="no-left-pad-list">
            <DynamicListItem>
              <TopAlignedListItemAvatar>
                <Gauge/>
              </TopAlignedListItemAvatar>
              <ListItemText>
                Månedsbeløpet vil normalt holde seg likt gjennom året. Det kan justeres hvis det skjer endringer i strømforbruket ditt eller svingninger i strømprisene. Hvis månedsbeløpet ditt endres,
                blir du varslet om dette.
              </ListItemText>
            </DynamicListItem>

            <DynamicListItem>
              <TopAlignedListItemAvatar>
                <Coins/>
              </TopAlignedListItemAvatar>
              <div>
                <SectionHeader isSmol>Betaling og faktura</SectionHeader>
                <ListItemText>
                  Du får videreført betalingsvalgene du har gjort hos strømleverandøren din – men hvis du har AvtaleGiro må du opprette dette på nytt i nettbanken din.
                </ListItemText>
              </div>
            </DynamicListItem>
          </List>
        </SteddiContainer>
      </Grid2>


    </Grid2>
  )
}